import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { RouterModule, RouterOutlet, provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations'
import { BrowserModule } from '@angular/platform-browser'

import { App_Route } from './app.routes';
// import { ColorPickerModule, ColorPickerService } from 'ngx-color-picker';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { environment } from '../environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { ColorPickerModule } from 'ngx-color-picker';
import { FlatpickrDefaults } from 'angularx-flatpickr';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { provideKeycloakAngular } from './keycloack.config';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { apiInterceptor } from './finapay/finapay.interceptors';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideKeycloakAngular(),
    provideRouter(App_Route),
    RouterOutlet,
    RouterModule,
    HttpClient,
    BrowserModule,
    provideAnimations(),
    FlatpickrDefaults,
    BrowserModule,
    AngularFireModule,
    AngularFireDatabaseModule,
    AngularFirestoreModule, CdkStepperModule,
    AngularFireAuthModule,
    provideHttpClient(),
    provideCharts(withDefaultRegisterables()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withInterceptors([includeBearerTokenInterceptor, apiInterceptor])
    ),
    importProvidersFrom(
      AngularFireModule.initializeApp(environment.firebase),
      ColorPickerModule,
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      }),
      ToastrModule.forRoot({
        timeOut: 15000, // 15 seconds
        closeButton: true,
        progressBar: true,
      }),
    ),
    {
      provide: LOCALE_ID,
      useValue: 'fr-FR' // 'de-DE' for Germany, 'fr-FR' for France ...
    }
  ]
};





